import ErrorFocus from "formik-error-focus";

export function FormikErrorFocus() {
  return (
    <ErrorFocus
      // See scroll-to-element for configuration options: https://www.npmjs.com/package/scroll-to-element
      formik={undefined as any}
      offset={0}
      align="top"
      focusDelay={200}
      ease="linear"
      duration={1000}
    />
  );
}
